import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export type Article = (typeof articles)[number];
export type Category = (typeof categories)[number];

export const siteInfo = {
  name: "511爆料",
  slogan: "分类导航 · 快速直达",
  intro:
    "覆盖娱乐圈瓜、职场瓜、校园瓜、同城瓜、行业瓜五大领域，分类清晰、更新快，热门小众都能找到，按图索骥不迷路。",
  email: "hey@511baoliao.example.com",
  baseUrl: "https://adfiz.cn",
};

export type CategoryTheme = {
  chip: string;
  dot: string;
  border: string;
  soft: string;
  icon: string;
  text: string;
  solid: string;
};

export const categoryTheme: Record<string, CategoryTheme> = {
  entertainment: {
    chip: "bg-primary-100 text-primary-900",
    dot: "bg-primary-500",
    border: "border-primary-200",
    soft: "bg-primary-50",
    icon: "bg-primary-500 text-background-50",
    text: "text-primary-700",
    solid: "bg-primary-500 text-background-50",
  },
  workplace: {
    chip: "bg-secondary-100 text-secondary-900",
    dot: "bg-secondary-500",
    border: "border-secondary-200",
    soft: "bg-secondary-50",
    icon: "bg-secondary-500 text-background-50",
    text: "text-secondary-700",
    solid: "bg-secondary-500 text-background-50",
  },
  campus: {
    chip: "bg-accent-100 text-accent-900",
    dot: "bg-accent-500",
    border: "border-accent-300",
    soft: "bg-accent-50",
    icon: "bg-accent-500 text-foreground-950",
    text: "text-accent-800",
    solid: "bg-accent-500 text-foreground-950",
  },
  local: {
    chip: "bg-primary-50 text-primary-800",
    dot: "bg-primary-400",
    border: "border-primary-200",
    soft: "bg-primary-50",
    icon: "bg-primary-600 text-background-50",
    text: "text-primary-800",
    solid: "bg-primary-600 text-background-50",
  },
  industry: {
    chip: "bg-secondary-100 text-secondary-800",
    dot: "bg-secondary-400",
    border: "border-secondary-200",
    soft: "bg-secondary-50",
    icon: "bg-secondary-700 text-background-50",
    text: "text-secondary-800",
    solid: "bg-secondary-700 text-background-50",
  },
};

export const allCategory = {
  slug: "all",
  name: "全部爆料",
  short: "全部",
  icon: "ri-layout-grid-line",
  tagline: "五大领域内容汇总，按时间与热度自由切换",
  desc: "把五个板块的内容放在一起浏览，适合没有明确目标、想先看看今天有什么的时候。",
  count: articles.length,
  updated: "实时更新",
  cover: articles[0].cover,
};

export function themeOf(slug: string): CategoryTheme {
  return categoryTheme[slug] || categoryTheme.entertainment;
}

export function getCategory(slug: string): Category | undefined {
  return categories.find((item) => item.slug === slug);
}

export function getCategoryName(slug: string): string {
  if (slug === "all") return allCategory.name;
  return getCategory(slug)?.name || "全部爆料";
}

export function getArticle(id: string | undefined): Article | undefined {
  if (!id) return undefined;
  return articles.find((item) => item.id === id);
}

export function getArticlesByCategory(slug: string): Article[] {
  if (slug === "all") return articles;
  return articles.filter((item) => item.category === slug);
}

export function searchArticles(list: Article[], keyword: string): Article[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return list;
  return list.filter((item) => {
    const haystack = `${item.title} ${item.summary} ${item.tags.join(" ")} ${item.categoryName}`.toLowerCase();
    return haystack.includes(kw);
  });
}

export function sortArticles(list: Article[], mode: "latest" | "hot"): Article[] {
  const next = [...list];
  if (mode === "hot") {
    next.sort((a, b) => b.views - a.views);
  } else {
    next.sort((a, b) => (a.date < b.date ? 1 : -1));
  }
  return next;
}

export function getHotArticles(limit = 5): Article[] {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestArticles(limit = 6): Article[] {
  return sortArticles(articles, "latest").slice(0, limit);
}

export function getRelatedArticles(current: Article, limit = 3): Article[] {
  const sameCategory = articles.filter(
    (item) => item.id !== current.id && item.category === current.category,
  );
  const others = articles.filter(
    (item) => item.id !== current.id && item.category !== current.category,
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function formatCount(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return String(value);
}

export function formatDate(value: string): string {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
}

export function formatShortDate(value: string): string {
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  return `${Number(parts[1])}月${Number(parts[2])}日`;
}